import React from 'react';
/* import Sound from 'react-sound';
import baltipstySound from '../assets/fondoKujipy.mp3';*/
import { useState } from 'react'; 
import Images from './images'
import './galery.css'
import useModal from '../hooks/useModal';
import ModalImage from './modal-image';
import { ImagenType } from '../components/Slider/Slider';
import SectionWrapper from "../components/ComponentWrapper/SectionWrapper";
import BreathingBackground from "../components/BreathingBackground/BreathingBackground";
import { useTranslation } from "react-i18next";


/* enum SOUNDSTATUS {
    PLAYING = 'PLAYING',
    STOPPED = 'STOPPED',
    PAUSED = 'PAUSED'
}
 */
const Galery = () =>{
    const { t } = useTranslation();

    //const [isPlaying, setIsPlaying] = useState<boolean>(false)
    const { isOpen, toggle } = useModal();
    const [actualImage, setActualImage] = useState<ImagenType>()

    /* useEffect(() => {
        setIsPlaying(true)
      },[]);  */

    const openFullscreenModal =  (item: ImagenType) =>{
        setActualImage(item)
        toggle()
    }

    const closeFullScreenModal = () => {
        setActualImage(undefined)
        toggle()
    }

    return (
        <BreathingBackground>
        <SectionWrapper>
        <div className='Content'>
            <div className='galeria'>
                <header className="gallery-header"><p className="eyebrow">{t("gallery.label")}</p><h1>{t("gallery.title")}</h1><p>{t("gallery.subtitle")}</p></header>
                <div className='galeria-container'>
                    <div className='image-container'>
                        {
                            Images.map( item => (
                                <img 
                                key={item.text}
                                className="img-galeria" 
                                src={item.src} id={item.text} alt={t("gallery.imageAlt", { name: item.text })} loading="lazy" decoding="async" tabIndex={0} onKeyDown={(event) => (event.key === "Enter" || event.key === " ") && openFullscreenModal(item)} onClick={() => openFullscreenModal(item)} />
                            )
                            )
                        }
                        
                    </div>
                </div>
                <ModalImage isOpen={isOpen} toggle={toggle} image={actualImage} images={Images} closeModal={closeFullScreenModal}></ModalImage>
            </div>
            {/* <Sound
                url={baltipstySound}
                playStatus={ isPlaying ? SOUNDSTATUS.PLAYING: SOUNDSTATUS.STOPPED}
                autoLoad={true}
                loop={true}
                volume={50}
            /> */}
        </div>
        </SectionWrapper>
        </BreathingBackground>
    )
}

export default Galery
